// extracted by css-extract-rspack-plugin
export default {"wrapper":"tOHYg","margin_top":"TdlPp","marginTop":"TdlPp"};